<template>
    <div id="page-text-fields">
        <v-container grid-list-xl fluid>
            <v-stepper v-model="step">
                <v-stepper-header>
                    <v-stepper-step step="1" :complete="step > 1">انتخاب طرح</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="2" :complete="step > 2">انتخاب محصول</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="3" :complete="step > 3">بررسی سبد خرید</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="4" :complete="step > 3">آدرس و تایید</v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-card>
                            <v-layout>
                                <v-flex>
                                    <v-text-field
                                            v-model="search"
                                            label="جستجو..."
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex
                                        :key="art.id"
                                        v-for="(art,_) in filterArtworks"
                                        lg4 sm12>
                                    <v-card @click="gotoBasket(art.art_id)" style="cursor: pointer;">
                                        <v-img :src="`/reseller_privates/org_artworks/`+art.base_image"
                                               height="250">
                                            <h4 class="black--text pa-3" style="text-shadow: 0 0 1px #ffffff">
                                                {{art.title}}
                                            </h4>
                                        </v-img>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <v-layout>
                            <v-flex xs12 md4>
                                <v-layout>
                                    <v-flex xs6 md6>
                                        <v-autocomplete
                                                label="نوع محصول"
                                                :items="c_art.blank_families"
                                                v-model="active_item.blank_family"
                                                autocomplete
                                                @change="ChangeFamily"
                                                menu-props="auto"
                                                required
                                                item-text="family_name"
                                                item-value="id"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs6 md6>
                                        <v-autocomplete
                                                label="محصول"
                                                :items="Blanks"
                                                v-model="active_item.blank_id"
                                                autocomplete
                                                menu-props="auto"
                                                required
                                                item-text="name"
                                                item-value="blanks_id"
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs6 md6>
                                        <v-autocomplete
                                                label="جنس محصول"
                                                :items="BlankTypes"
                                                v-model="active_item.blanks_type"
                                                autocomplete
                                                menu-props="auto"
                                                required
                                                item-text="gender_name"
                                                item-value="type_id"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs6 md6>
                                        <v-autocomplete
                                                label="اندازه"
                                                :items="BlankSizes"
                                                v-model="active_item.blanks_size"
                                                autocomplete
                                                menu-props="auto"
                                                required
                                                item-text="size_name"
                                                item-value="size_id"
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-layout>

                                <div v-if="BlankColors.length > 0 ">
                                    <v-layout>
                                        <v-flex><h5>رنگ‌</h5></v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <v-layout>
                                        <v-flex
                                                xs2
                                                md1
                                                v-bind:key="k"
                                                v-for="(color,k) in BlankColors"
                                        >
                                            <OrderColor
                                                    v-model="active_item.color_id"
                                                    :bc="color"
                                                    @ColorChange="changeColor"
                                            ></OrderColor>
                                        </v-flex>
                                    </v-layout>
                                </div>

                                <div v-if="active_family.user_can_chose_side !== 'No' && c_art.print_sides.length > 1">
                                    <v-layout v-if="active_family.user_can_chose_side !== 'Multiple'">
                                        <v-flex><h5>جهت</h5></v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <v-layout v-if="active_family.user_can_chose_side !== 'Multiple'">
                                        <v-flex
                                                v-bind:key="k"
                                                v-for="(side,k) in c_art.print_sides"
                                                v-model="active_item.additional_parameters"
                                                :value="side.id"
                                        >
                                            <v-checkbox
                                                    :label="side.side_name"
                                                    v-model="active_item.sides"
                                                    :value="side.id"
                                            ></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout v-if="active_family.user_can_chose_side !== 'Single'">
                                        <v-flex>
                                            <v-autocomplete
                                                    label="جهت طرح"
                                                    :items="c_art.print_sides"
                                                    v-model="active_item.sides[0]"
                                                    autocomplete
                                                    menu-props="auto"
                                                    required
                                                    item-text="side_name"
                                                    item-value="id"
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </div>
                                <div v-if="BlanksAdditionalFields.length > 0 ">
                                    <v-layout>
                                        <v-flex><h5>قابلیت‌های اضافه</h5></v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <v-layout>
                                        <v-flex
                                                v-bind:key="k"
                                                v-for="(ba,k) in BlanksAdditionalFields"
                                                v-model="active_item.additional_parameters"
                                                :value="ba.ad_id"
                                        >
                                            <v-checkbox
                                                    :label="ba.title"
                                                    v-model="active_item.additional_parameters"
                                                    :value="ba.ad_id"
                                            ></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </div>

                                <v-layout>
                                    <v-flex>
                                        <v-text-field
                                                type="number"
                                                label="تعداد"
                                                v-model="active_item.quantity"
                                                data-number
                                                min="1"
                                                max="1000"
                                                @change="QChange($event)"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex class="pt-4">

                                        <v-chip>
                                            قیمت نهایی:
                                            {{Math.round(total*active_item.quantity/10, 10)}}
                                            تومان
                                        </v-chip>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 md8>
                                <v-carousel>
                                    <v-carousel-item
                                            v-bind:key="k"
                                            v-for="(ps,k) in PrintSides"
                                    >
                                        <v-img
                                                v-if="active_item.blanks_type > 0 && active_item.blank_id > 0 && active_item.blanks_size > 0 && active_item.color_id > 0"
                                                :src="`/mock/` + this.active_item.art_id + `/` + active_item.blank_id + `/` + active_item.blanks_type + `/` + active_item.color_id + `/` + active_item.blanks_size + `/` + ps.id +`/mock.jpg`"
                                        ></v-img>
                                    </v-carousel-item>
                                </v-carousel>
                            </v-flex>
                        </v-layout>

                        <v-btn flat @click="step = 1">برگشت</v-btn>
                        <v-btn
                                v-if="basket_items.length > 0"
                                @click="step = 3"
                                color="success">

                            <v-icon>shopping_basket</v-icon>
                            &nbsp;
                            سبد خرید
                        </v-btn>
                        <v-btn
                                v-if="CurrentIsOk"
                                color="primary" @click="addBasketItem()">
                            ادامه
                            &nbsp;
                            <v-icon>arrow_back</v-icon>
                        </v-btn>
                        <v-btn
                                v-else
                                color="primary" disabled>
                            ادامه
                            &nbsp;
                            <v-icon>arrow_back</v-icon>
                        </v-btn>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <v-layout row wrap>
                            <v-flex
                                    :key="k"
                                    v-for="(bi,k) in basket_items"
                                    lg4 sm12>
                                <v-card>
                                    <v-card-text>
                                        <v-img @click="ActivateItem(k)" style="cursor: pointer;"
                                               :src="`/reseller_privates/org_artworks/`+artwork(bi.art_id).base_image"
                                               height="250">
                                            <h4 class="black--text pa-3" style="text-shadow: 0 0 1px #ffffff">
                                                {{artwork(bi.art_id).title}} ({{bi.quantity}} عدد)
                                            </h4>
                                        </v-img>
                                        <v-btn absolute left bottom icon class="error" color="error"
                                               @click="removeItemByIndex(k)">
                                            <v-icon>remove</v-icon>
                                        </v-btn>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-btn flat @click="removeLastItem()">برگشت</v-btn>
                        <v-btn color="success btn-lg" @click="newItem()">
                            <v-icon>add_circle</v-icon>
                            &nbsp;
                            افزودن
                        </v-btn>
                        <v-btn color="primary btn-lg" @click="step = 4">
                            ادامه
                            &nbsp;
                            <v-icon>arrow_back</v-icon>
                        </v-btn>
                    </v-stepper-content>
                    <v-stepper-content step="4">

                        <v-form action="" lazy-validation v-model="valid" ref="form">
                            <v-layout class="align-content-center">
                                <v-flex class="text-xs-center">
                                    <v-chip color="green" text-color="white"> مجموع خرید
                                        {{totalPrice}}
                                        تومان
                                    </v-chip>
                                    <v-chip color="blue" text-color="white"> هزینه‌ی حمل
                                        {{transfer_cost}}
                                        تومان
                                    </v-chip>
                                </v-flex>
                            </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-autocomplete
                                        label="استان"
                                        name="23432rwedfsewf"
                                        :items="z_provinces"
                                        v-model="province_id"
                                        menu-props="auto"
                                        required
                                        autocomplete="odgterff"
                                        item-text="name"
                                        item-value="id"
                                        :rules="[rules.required]"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex>
                                <v-autocomplete
                                        label="شهر"
                                        :items="cities"
                                        name="ejegdgdf"
                                        v-model="order_details.city_id"
                                        autocomplete="regrtg"
                                        menu-props="auto"
                                        required
                                        item-text="name"
                                        item-value="id"
                                        :rules="[rules.required]"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex>
                                <v-autocomplete
                                        label="نوع ارسال"
                                        :items="deliveryMethods"
                                        v-model="order_details.delivery_type"
                                        autocomplete="ergrtg"
                                        menu-props="auto"
                                        required
                                        item-text="title"
                                        item-value="d_id"
                                        :rules="[rules.required]"
                                ></v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs3>
                                <v-text-field
                                        label="نام گیرنده"
                                        required
                                        v-model="order_details.receiver_name"
                                        :rules="[rules.required]"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs5>
                                <v-text-field
                                        label="آدرس"
                                        v-model="order_details.address"
                                        required
                                        maxlength="255"
                                        :rules="[rules.required]"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs2>
                                <v-text-field
                                        label="موبایل"
                                        data-number
                                        maxlength="11"
                                        required
                                        v-model="order_details.mobile"
                                        :rules="[rules.required]"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs2>
                                <v-text-field
                                        label="کد پستی"
                                        data-number
                                        maxlength="10"
                                        v-model="order_details.postal"
                                        :rules="[rules.required]"
                                        required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-textarea
                                        label="توضیحات اضافه"
                                        maxlength="255"
                                        v-model="order_details.user_description"
                                ></v-textarea>
                            </v-flex>
                        </v-layout>

                        </v-form>
                        <v-btn flat @click="step = 3">برگشت</v-btn>
                        <v-btn color="success btn-lg" @click="Finalize">
                            <v-icon>done_all</v-icon>
                            &nbsp;
                            ثبت سفارش
                        </v-btn>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>

        </v-container>
        <v-snackbar
                :timeout="snackbar.timeout"
                :color="snackbar.color"
                :top="snackbar.y === 'top'"
                :bottom="snackbar.y === 'bottom'"
                :right="snackbar.x === 'right'"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-dialog
                v-model="payment_dialog"
                width="500"
        >
            <v-card>
                <v-form target="_blank" method="post"
                      :action="this.axios.defaults.baseURL + `/../redirect_to_gateway?reseller_id=`+res_id">
                    <v-card-title
                            class="headline grey lighten-2"
                            primary-title
                    >
                        پرداخت
                    </v-card-title>

                    <v-card-text>
                        <v-text-field
                                data-number
                                v-model="payment_amount"
                                maxlength="9"
                                name="amount"
                                label="مبلغ"
                        ></v-text-field>
                        <small>{{toPersian(payment_amount)}}</small>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="success"
                                @click="dialog = false"
                                type="submit"
                        >
                            پرداخت
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import VWidget from '../../components/VWidget';
import HttpErrorToSnackbar from '../../api/HttpErrorToSnackbar';
import OrderColor from '../../components/widgets/color/OrderColor';

export default {
  name: 'new',
  components: {
    OrderColor,
    VWidget
  },
  data () {
    return {
      step: 1,
      valid: true,
      res_id: 0,
      payment_dialog: false,
      payment_amount: 0,
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      basket_items: [],
      active_item: {
        additional_parameters: [],
        blank_family: 0,
        blanks_type: 0,
        blanks_size: 0,
        color_id: 0,
        blank_id: 0,
        quantity: 1,
        art_id: 0,
        sides: [],
      },
      active_item_default: {},
      order_details: {
        delivery_type: 0,
        city_id: 118,
        receiver_name: '',
        user_description: '',
        address: '',
        postal: '',
        mobile: '',
        location: '35.7168309,51.3647892',
      },
      total: 0,
      c_art: {
        categories: [],
        blanks: [],
        blanks_colors: [],
        blanks_sizes: [],
        blanks_types: [],
        blanks_additional_fields: [],
        blank_families: [],
        print_sides: [],
        artwork_assets: [],
        stock: [],
      },
      active_family: { user_can_chose_side: 'No' },
      artworks: [],
      z_provinces: [],
      z_cities: [],
      cities: [],
      delivery_gs: [],
      province_id: 0,
      transfer_cost: 0,
      blanks_delivery_attrs: [],
      delivery_classes_gates: [],
      search: '',
      rules: {
        required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
      }
    };
  },
  computed: {
    deliveryMethods: function () {
      let data = [0, 0, 0]; // weight, width, height
      this.basket_items.forEach(item => {
        data[0] += item.weight;
        if (data[1] < item.width) {
          data[1] = item.width;
        }
        if (data[2] < item.height) {
          data[2] = item.height;
        }
      });
      return this.delivery_gs.filter(dg => dg.cities.findIndex(dgc =>
        dgc.city_id === this.order_details.city_id) > -1 &&
          dg.max_weight >= data[0] &&
          dg.max_width >= data[1] &&
          dg.max_height >= data[2]
      );
    },
    Blanks: function () {
      if (this.c_art.blanks.length === 0 || this.active_item.blank_family === 0) {
        return [];
      }
      let f_blanks = this.c_art.blanks.filter(
        b => b.family_id === this.active_item.blank_family && this.c_art.stock.findIndex(s => s.blank_id === b.blanks_id && (s.quantity === -1 || s.quantity > 0)) > -1
      );
      if (f_blanks.length === 0) {
        this.snackbar.snackbar = true;
        this.snackbar.color = 'red';
        this.snackbar.text = 'این نوع محصول تمام شده است.';
      }
      return f_blanks;
    },
    CurrentIsOk: function () {
      if (this.active_item.art_id !== 0 && this.active_item.color_id !== 0 && this.active_item.quantity > 0) {
        return true;
      }
      return false;
    },
    PrintSides: function () {
      return this.c_art.print_sides.filter(ps => ps.family_id === this.active_item.blank_family);
    },
    BlankColors: function () {
      if (this.c_art.blanks_colors.length === 0 || this.active_item.blanks_type === 0 || this.active_item.blank_id === 0 || this.active_item.blanks_size === 0) {
        return [];
      }
      let colors = this.c_art.blanks_colors.filter(
        ps => ps.blanks_id === this.active_item.blank_id && this.c_art.stock.findIndex(s => s.blank_id === ps.blanks_id && ps.color_id === s.blank_color && (s.quantity === -1 || s.quantity > 0)) > -1
      );
      if (colors.length > 0) {
        this.active_item.color_id = colors[0].color_id;
      }
      return colors;
    },
    BlanksAdditionalFields: function () {
      return this.c_art.blanks_additional_fields.filter(ba => ba.blanks_id === this.active_item.blank_id);
    },
    BlankSizes: function () {
      if (this.c_art.blanks_sizes.length === 0 || this.active_item.blank_id === 0) {
        return [];
      }
      let result = this.c_art.blanks_sizes.filter(
        ps => ps.blanks_id === this.active_item.blank_id && this.c_art.stock.findIndex(s => s.blank_id === ps.blanks_id && ps.size_id === s.blank_size && (s.quantity === -1 || s.quantity > 0)) > -1
      );
      if (result.length > 0) {
        this.active_item.blanks_size = result[0].size_id;
      }
      return result;
    },
    BlankTypes: function () {
      if (this.c_art.blanks_types.length === 0 || this.active_item.blank_id === 0) {
        return [];
      }
      let result = this.c_art.blanks_types.filter(
        ps => ps.blanks_id === this.active_item.blank_id && this.c_art.stock.findIndex(s => s.blank_id === ps.blanks_id && ps.type_id === s.blank_type && (s.quantity === -1 || s.quantity > 0)) > -1
      );
      if (result.length > 0) {
        this.active_item.blanks_type = result[0].type_id;
      }
      return result;
    },
    filterArtworks: function () {
      if (this.search.length === 0) {
        return this.artworks;
      }
      return this.artworks.filter(art => art.title.includes(this.search));
    },
    totalPrice: function () {
      let out = 0;
      this.basket_items.forEach(bi => {
        out += ((bi.total) * bi.quantity);
      });
      return Math.round(out / 10);
    }
  },
  watch: {
    active_item: {
      handler () {
        this.Calculate();
      },
      deep: true
    },
    province_id: function (n) {
      this.cities = this.z_cities.filter(c => c.vip_province_id === n);
    }
  },
  mounted () {
    this.active_item_default = Object.assign({}, this.active_item);
    this.c_art_default = Object.assign({}, this.c_art);
    this.axios.get('/reseller/artworks/?finalized=1')
      .then(response => {
        this.artworks = response.data.Data;
      }).catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    this.axios.get('/reseller/who_am_i')
      .then(response => {
        this.res_id = response.data.id;
      }).catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    this.axios.get('/reseller/z_city/')
      .then(response => {
        this.z_cities = response.data.Data;
        this.axios.get('/reseller/z_province/')
          .then(response => {
            this.z_provinces = response.data.Data;
            this.province_id = 8;
          }).catch(error => {
            this.snackbar = HttpErrorToSnackbar(error);
          });
      }).catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    this.axios.get('/reseller/delivery_gateways/')
      .then(response => {
        this.delivery_gs = response.data;
      }).catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    this.axios.get('/reseller/blanks_delivery_attrs/')
      .then(response => {
        this.blanks_delivery_attrs = response.data.Data;
      }).catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
    this.axios.get('/reseller/delivery_classes_gates/')
      .then(response => {
        this.delivery_classes_gates = response.data.Data;
      }).catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  },
  methods: {
    removeItemByIndex: function (i) {
      this.basket_items = this.basket_items.filter((_, k) => k !== i);
    },
    removeLastItem: function () {
      this.step = 2;
      this.basket_items.pop();
    },
    addBasketItem: function () {
      this.step = 3;
      this.active_item.total = this.total;

      this.active_item.weight = 0;
      this.active_item.width = 0;
      this.active_item.height = 0;

      let bda_index = this.blanks_delivery_attrs.findIndex(bda => bda.blank_id === this.active_item.blank_id && bda.blank_type === this.active_item.blanks_type && bda.blank_size === this.active_item.blanks_size);
      if (bda_index > -1) {
        this.active_item.weight = this.blanks_delivery_attrs[bda_index].weight * this.active_item.quantity;
        this.active_item.height = this.blanks_delivery_attrs[bda_index].height;
        this.active_item.width = this.blanks_delivery_attrs[bda_index].width;
      }

      this.basket_items.push(this.active_item);
    },
    artwork: function (ArtID) {
      let id = this.artworks.findIndex(art => art.art_id === ArtID);
      if (id === -1) {
        return {
          base_image: '',
          title: ''
        };
      }
      return this.artworks[id];
    },
    newItem: function () {
      this.step = 1;
      this.active_item = this.active_item_default;
      this.c_art = this.c_art_default;
    },
    ActivateItem: function (i) {
      this.active_item = this.basket_items[i];
      this.removeItemByIndex(i);
      this.gotoBasket(this.active_item.art_id);
    },
    QChange: function (q) {
      this.active_item.quantity = parseInt(q, 10);
      if (this.active_item.blank_family === 0 || this.active_item.blank_id === 0 || this.active_item.blanks_size === 0 || this.active_item.color_id === 0 || this.active_item.blanks_type === 0) {
        return null;
      }
      let i = this.c_art.stock.findIndex(s => s.blank_id === this.active_item.blank_id && s.blank_size === this.active_item.blanks_size && s.blank_color === this.active_item.color_id && s.blank_type === this.active_item.blanks_type);
      if (i < 0) {
        this.snackbar.snackbar = true;
        this.snackbar.text = 'این نوع محصول یافت نشد!';
        this.snackbar.color = 'red';
        return null;
      }
      if (this.c_art.stock[i].quantity > -1 && this.c_art.stock[i].quantity < q) {
        this.snackbar.snackbar = true;
        this.snackbar.text = 'به اندازه‌ی درخواستی شما محصول وجود ندارد!';
        this.snackbar.color = 'orange';
        this.active_item.quantity = this.c_art.stock[i].quantity;
      }
    },
    Calculate: function () {
      let base_price = 0;
      if (typeof this.c_art.blank_prices === 'undefined') {
        return;
      }
      let prices = this.c_art.blank_prices.filter(bp => bp.blank_id === this.active_item.blank_id);
      if (prices.length > 0) {
        let biggers = prices.filter(p => p.to_quantity >= this.active_item.quantity);
        if (biggers.length > 0) {
          base_price = biggers[0].price;
        } else {
          base_price = prices[prices.length - 1].price;
        }
      }
      let add_prices = 0;
      this.active_item.additional_parameters.forEach((c) => {
        let i = this.c_art.blanks_additional_fields.findIndex(a => a.ad_id === c);
        if (i > -1) {
          add_prices += this.c_art.blanks_additional_fields[i].additional_price;
        }
      });

      let i = this.c_art.blanks_colors.findIndex(c => this.active_item.color_id === c.color_id);
      if (i > -1) {
        add_prices += this.c_art.blanks_colors[i].additional_price;
      }

      i = this.c_art.blanks_sizes.findIndex(bs => this.active_item.blanks_size === bs.size_id);
      if (i > -1) {
        add_prices += this.c_art.blanks_sizes[i].additional_price;
      }

      i = this.c_art.blanks_types.findIndex(t => this.active_item.blanks_type === t.type_id);
      if (i > -1) {
        add_prices += this.c_art.blanks_types[i].additional_price;
      }

      let print_price = 0;
      this.active_item.sides.forEach((s) => {
        let i = this.c_art.print_sides.findIndex(a => a.id === s);
        if (i > -1) {
          print_price += this.c_art.print_sides[i].print_price;
        }
      });

      let reseller_commission = 0;
      i = this.c_art.artwork_assets.findIndex(a => a.family_id === this.active_item.blank_family && a.artwork_id === this.active_item.art_id);
      if (i > -1) {
        reseller_commission = this.c_art.artwork_assets[i].commission;
      }

      this.total = base_price + print_price + add_prices + reseller_commission;
    },
    ChangeFamily: function (fa) {
      let i = this.c_art.blank_families.findIndex(f => f.id === fa);
      if (i > -1) {
        this.active_family = this.c_art.blank_families[i];
      } else {
        this.active_family = { user_can_chose_side: 'No' };
      }
      this.active_item.sides = [0];
      if (this.c_art.print_sides.length === 1) {
        this.active_item.sides = [this.c_art.print_sides[0].id];
      }

    },
    changeColor: function (color_id) {
      this.active_item.color_id = color_id;
    },
    gotoBasket: function (artID) {
      this.axios.get('/reseller/artwork_store_detailed/' + artID)
        .then(response => {
          this.c_art = response.data;
          this.active_item.art_id = artID;
          /* if (this.c_art.blank_families.length === 1) {
                        this.active_item.blank_family = this.c_art.blank_families[0].id;
                      } */
          this.step = 2;
        }).catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    Finalize: function () {
      if (!this.$refs.form.validate()) {
        window.getApp.$emit('INVALID_FORM');
        return;
      }
      this.axios.get('/reseller/balance')
        .then(response => {
          if ((this.totalPrice + this.transfer_cost) > response.data) {
            this.snackbar.snackbar = true;
            this.snackbar.text = 'موجودی شما کافی نیست';
            this.snackbar.color = 'red';
            this.paymentDialog(Math.abs(response.data - ((this.totalPrice + this.transfer_cost) * 10)));
            return;
          }
          this.sendOrderData();
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    paymentDialog: function (amount) {
      this.payment_dialog = true;
      this.payment_amount = amount;
    },
    sendOrderData: function () {
      let data = {
        items: this.basket_items,
        order_data: this.order_details
      };
      this.axios.post('/reseller/basket', data)
        .then(response => {
          if (response.status === false) {
            this.payment_dialog((this.totalPrice + this.transfer_cost) * 10);
            return;
          }
          this.snackbar.text = 'با موفقیت ثبت شد!';
          this.snackbar.color = 'green';
          this.snackbar.snackbar = true;
        }).catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/order/new.vue